import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import { updateSpeaker } from '../speakers';
import { ProjectState } from './types';
import handleSpeakerMutations from './helpers/extra-reducers/handle-speaker-mutations';

/*
  Why extraReducers?
  Because we don't have access to updating the entire redux store from within reducers.
  So in the below examples, when a speaker is updated from the speakers slice (updateSpeaker), we need to
  make sure the speakers in the associated project sessions are updated to remain in sync,
  so we "listen" to the updateSpeaker reducer and update our project accordingly.
*/
export const extraReducers = (builder: ActionReducerMapBuilder<ProjectState>) => {
  // Optimistically update redux to get immediate user feedback for updated speakers
  builder.addCase(updateSpeaker.pending, (state, action) => {
    handleSpeakerMutations(action.meta.arg.speaker, state);
  });
  // If successful, re-update with the returned speaker from the api (becasue that could have updated translations)
  builder.addCase(updateSpeaker.fulfilled, (state, action) => {
    handleSpeakerMutations(action.payload, state);
  });
  // if rejected, reset back to the original speaker
  builder.addCase(updateSpeaker.rejected, (state, action) => {
    handleSpeakerMutations(action.meta.arg.originalSpeaker, state);
  });
};
